<csl-svg-workspace #svgWorkspace [p]="panel" [axisBase]="getAxisCoordStart()" [axis]="true"> </csl-svg-workspace>
